var map = {
	"./en/hos.yml": 154,
	"./en/main.yml": 34,
	"./en/news.yml": 155,
	"./en/sfs.yml": 156,
	"./fr/csu.yml": 157,
	"./fr/faq.yml": 158,
	"./fr/hos.yml": 159,
	"./fr/hos2.yml": 160,
	"./fr/main.yml": 35,
	"./fr/news.yml": 161,
	"./fr/rgpd.yml": 162,
	"./fr/sfs.yml": 163
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 153;